import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';
import formatMoney from '../../../utils/formatMoney';
import { ProvincialBenchmarkStatistics } from '@tassomutuo-backoffice/types';

interface Props {
  provincialStatistics?: ProvincialBenchmarkStatistics[];
  isPrinting?: boolean;
}

const DashboardProvincialStatisticsTable = ({
  provincialStatistics,
  isPrinting,
}: Props) => {
  if (!provincialStatistics || provincialStatistics.length === 0) {
    return null;
  }

  // Filtra se con 0 lead ricevute
  const filteredStatistics = provincialStatistics.filter(
    (stat) =>
      stat.benchmarkStatisticsAllPeriod.statistics.numberOfReceivedLeads > 0
  );

  if (filteredStatistics.length === 0) {
    return null;
  }

  const tableColumns: GridColDef<ProvincialBenchmarkStatistics>[] = [
    {
      field: 'province',
      headerName: 'Provincia',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'numberOfReceivedLeads',
      headerName: 'Lead Ricevute',
      minWidth: 120,
      type: 'number',
      valueGetter: (params) =>
        params.row.benchmarkStatisticsAllPeriod.statistics
          .numberOfReceivedLeads,
    },
    {
      field: 'estimatedMortgages',
      headerName: 'Mutui Stimati',
      minWidth: 130,
      type: 'number',
      valueGetter: (params) =>
        params.row.benchmarkStatisticsAllPeriod.statistics.estimatedMortgages,
      valueFormatter: (params) => params.value?.toFixed(2),
    },
    {
      field: 'crEstimatedMortgages',
      headerName: 'Tasso di conversione',
      minWidth: 130,
      type: 'number',
      valueGetter: (params) =>
        params.row.benchmarkStatisticsAllPeriod.statistics.crEstimatedMortgages,
      valueFormatter: (params) => (params.value ? `${params.value}%` : ''),
    },
    {
      field: 'estimatedRevenue',
      headerName: 'Revenue Stimato',
      minWidth: 150,
      type: 'number',
      valueGetter: (params) =>
        params.row.benchmarkStatisticsAllPeriod.statistics.estimatedRevenue,
      valueFormatter: (params) => formatMoney(params.value),
    },
    {
      field: 'revenuePerLead',
      headerName: 'Revenue per Lead',
      minWidth: 130,
      type: 'number',
      valueGetter: (params) =>
        params.row.benchmarkStatisticsAllPeriod.statistics.revenuePerLead,
      valueFormatter: (params) => formatMoney(params.value),
    },
    {
      field: 'effectiveRevenue',
      headerName: 'Fatturato Totale',
      minWidth: 150,
      type: 'number',
      valueGetter: (params) =>
        params.row.benchmarkStatisticsAllPeriod.statistics.effectiveRevenue,
      valueFormatter: (params) => formatMoney(params.value),
    },

    /*  {
      field: 'leadsWonCount',
      headerName: 'Lead Vinte',
      minWidth: 110,
      valueGetter: (params) =>
        params.row.benchmarkStatisticsAllPeriod.statistics.leadsWonCount,
    },*/
    {
      field: 'lostRevenue',
      headerName: 'Fatturato Perso',
      minWidth: 140,
      type: 'number',
      valueGetter: (params) =>
        params.row.benchmarkStatisticsAllPeriod.statistics.lostRevenue,
      valueFormatter: (params) => formatMoney(params.value),
    },
    /*  {
      field: 'lostRevenueLeadsCount',
      headerName: 'Lead Perse',
      minWidth: 110,
      valueGetter: (params) =>
        params.row.benchmarkStatisticsAllPeriod.statistics
          .lostRevenueLeadsCount,
    },*/
  ];

  return (
    <Box
      sx={{
        backgroundColor: '#FAFAFA',
        padding: 4,
        mt: 6,
        borderRadius: '16px',
        border: '1px solid gainsboro',
      }}
    >
      <Typography variant="h4" mb={1} fontWeight="bold">
        Statistiche per Provincia
      </Typography>
      <Typography variant="h6" mb={4}>
        Performance del team suddivise per provincia di provenienza delle lead
      </Typography>
      <Box
        sx={{
          width: '100%',
          minWidth: isPrinting ? 1100 : undefined,
        }}
      >
        <DataGrid
          getRowId={(row) => row.province}
          columns={tableColumns}
          rows={filteredStatistics}
          disableRowSelectionOnClick
          autoHeight
          getRowHeight={() => 'auto'}
          hideFooterPagination
          hideFooter
          sx={{
            '& .MuiDataGrid-cell': {
              border: '1px solid rgba(224, 224, 224, 1)',
              color: '#717680',
              fontWeight: '700',
              py: 1,
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
              color: 'secondary.main',
              fontSize: '16px',
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default DashboardProvincialStatisticsTable;
